'use client';

import type { ReactNode } from 'react';
import dynamic from 'next/dynamic';

const TmaApp = dynamic(() => import('./TmaApp'), { ssr: false });

export default function TmaAppMount({ children }: { children: ReactNode }) {
  return <TmaApp>{children}</TmaApp>;
}
